import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import PropTypes from "prop-types";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import Box from "@material-ui/core/Box";
import clsx from "clsx";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Moment from "react-moment";

const useStyles = makeStyles((theme) => ({
  contractMenu: {
    fontSize: 18,
    cursor: "pointer",
  },
  active: {
    color: "#ff4717",
  },
  leftBoxContract: {
    borderRight: "1px solid #979797",
  },
  tableLayoutBox:{
    marginBottom:"30px"
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));
const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);
export default function ContractDetails(props) {
  const { row } = props;
  const [activeKey, setActiveKey] = useState("SalesAgreementLines");
  const classes = useStyles();
  const getFlagColor=(flag)=>{
    var flagcls;
    switch(flag) {
      case "Good":
        flagcls={
          color:"#006600"
        };
        break;
      case "OverDue":
        flagcls={
          color:"red"
        };
        break;
        case "Due Soon":
        flagcls={
          color:"orange"
        };
        break;
      default:
        
    }
    return flagcls;
  
  };
  return (
    <React.Fragment>
     <TableContainer
              component={Paper}
              className={clsx(classes.TableTheme)}
            >
              <Table
               
                className={classes.tableLayout}
              >
                <>
                  <TableRow>
                    <StyledTableCell >
                     Equipment 
                    </StyledTableCell>
                    <StyledTableCell >
                      Make
                    </StyledTableCell>
                    <StyledTableCell >
                      Model
                    </StyledTableCell>
                    <StyledTableCell >
                    LO Brand 
                    </StyledTableCell>
                    <StyledTableCell >
                    LO Grade
                    </StyledTableCell>
                    <StyledTableCell >
                     Last Sample Date
                    </StyledTableCell>
                    <StyledTableCell >
                    Sampling Frequecy
                    </StyledTableCell>
                    <StyledTableCell >
                     Next Sample Date
                    </StyledTableCell>
                    <StyledTableCell >
                    Flag
                    </StyledTableCell>
                  </TableRow>
                </>
                <TableBody>
                  {row.EquipmentList.length
                    ? row.EquipmentList.map((Item) => (
                        <TableRow>
                        <TableCell >
                            {Item.Equipment}
                        </TableCell>
                        <TableCell >
                            {/* {Item.Make} */}
                           {/* {Item.make ?<Moment format="DD MMM YYYY"> */}{Item.Make}{/* </Moment>  : ""} 
   */}                      </TableCell>
                        <TableCell >
                            {/* {Item.Model} */}
                          {/* {Item.model ?<Moment format="DD MMM YYYY"> */}{Item.Model}{/* </Moment>  : ""}  */} 

                        </TableCell>
                        <TableCell >
                            {Item.LastKnownLubeBrand}
                         {/* {Item.LastKnownLubeBrand ?<Moment format="DD MMM YYYY">{Item.LubeMake}</Moment>   : " "}    */}

                        </TableCell>
                        <TableCell >
                            {Item.LastKnownLubeGrade}
                            {/* {Item.LastKnownLubeGrade ? <Moment format="DD MMM YYYY">{Item.LubeModel}</Moment> : ""} */}

                        </TableCell>
                        <TableCell >
                            {/* {Item.LastSampleDate} */}
                          {Item.LastSampleDate ?  <Moment format="DD MMM YYYY">{Item.LastSampleDate}</Moment>  : ""} 
                        </TableCell>
                        <TableCell >
                            {Item.SamplingFrequency==0?"Ad hoc":Item.SamplingFrequency} 
                          {/* {Item.SamplingFrequency ? 
                        <React.Fragment>
                          <Moment format="DD">{Item.SamplingFrequency}</Moment> Days 
                        </React.Fragment> 
                        : ""}   */}
                            
                        </TableCell>
                        <TableCell >
                            {/* {Item.NextSampleDate} */}
                          { Item.NextSampleDate ?    <Moment format="DD MMM YYYY">{Item.NextSampleDate}</Moment>  : "" }

                        </TableCell>
                        <TableCell style={getFlagColor(Item.Flag)}>
                            {Item.SamplingFrequency==0?"":Item.Flag}
                        </TableCell>
                        </TableRow>

                      ))
                    : (<TableCell colSpan="4">
                      <Box textAlign="center" m={2}>No Record Found</Box>
                      </TableCell>)}
                </TableBody>
              </Table>
            </TableContainer>
    </React.Fragment>
  );
}
